module.exports = __webpack_public_path__ + "img/scene-port.3cf6ba3e.jpg";